import { Alert } from "capitalrx-components-2.0/lib";
import { OverlayContainer, TooltipContainer } from "capitalrx-components-2.0/lib/general";
import { Provider } from "react-redux";
import { BasicRoutes } from "@/basic/routes";
import { store } from "@/basic/store";

import { ThemeSelector } from "@/basic/context";

export const BasicRoot = (): JSX.Element => {
  const { AlertProvider } = Alert;

  return (
    <OverlayContainer>
      <TooltipContainer>
        <Provider store={store}>
          <ThemeSelector>
            <AlertProvider>
              <BasicRoutes />
            </AlertProvider>
          </ThemeSelector>
        </Provider>
      </TooltipContainer>
    </OverlayContainer>
  );
};
